<template>
    <div class="wrap">
        <div class="card" role="main" aria-labelledby="loginTitle">
            <div class="logo">
                <div class="icon">L</div>
                <div>
                    <h1 id="loginTitle" class="title">欢迎回来</h1>
                    <div class="subtitle">请输入你的账户信息继续</div>
                </div>
            </div>

            <form @submit.prevent="onSubmit" autocomplete="on" novalidate>
                <div class="field">
                    <label for="username">手机号 / 邮箱 / 用户名</label>
                    <input v-model="username" id="username" type="text" placeholder="输入手机号/邮箱/用户名" required />
                    <div v-if="errors.username" class="error">{{ errors.username }}</div>
                </div>

                <div class="field input-with-btn">
                    <label for="password">密码</label>
                    <input v-model="password" :type="showPwd ? 'text' : 'password'" id="password" placeholder="请输入密码"
                        required minlength="6" />
                    <!-- <button type="button" @click="togglePwd">{{ showPwd ? '隐藏' : '显示' }}</button> -->
                    <div v-if="errors.password" class="error">{{ errors.password }}</div>
                </div>

                <div class="actions">
                    <label class="checkbox">
                        <input v-model="remember" type="checkbox" /> 记住我
                    </label>
                    <a class="forgot" href="#" @click.prevent="onForgot">忘记密码？</a>
                </div>

                <div style="margin-top:12px">
                    <button class="btn" type="submit" :disabled="loading">{{ loading ? '登录中...' : '登录' }}</button>
                </div>

                <!-- <div class="oauth">
                    <button type="button" @click="oauth('weixin')">微信登录</button>
                    <button type="button" @click="oauth('apple')">Apple</button>
                    <button type="button" @click="oauth('google')">Google</button>
                </div> -->

                <div class="helper">还没有账号？ <a href="#" @click.prevent="onSignup">立即注册</a></div>

                <div v-if="errors.global" class="error">{{ errors.global }}</div>
            </form>
        </div>
    </div>
</template>

<script>
import { userLogin } from '../../api/index'
import { saveAuthToken } from '../../utils/auth'
export default {
    name: "LoginPage",
    data() {
        return {
            username: "",
            password: "",
            remember: false,
            showPwd: false,
            loading: false,
            errors: {}
        };
    },
    mounted() {
        try {
            const saved = JSON.parse(localStorage.getItem("h5_login_pref") || "{}");
            if (saved.remember) {
                this.remember = true;
                this.username = saved.username || "";
            }
        } catch (e) { }
    },
    methods: {
        togglePwd() {
            this.showPwd = !this.showPwd;
        },
        validate() {
            this.errors = {};
            if (!this.username.trim()) {
                this.errors.username = "用户名/邮箱/手机号不能为空";
            }
            if (!this.password) {
                this.errors.password = "请输入密码";
            } else if (this.password.length < 6) {
                this.errors.password = "密码长度至少 6 位";
            }
            return Object.keys(this.errors).length === 0;
        },
        async onSubmit() {
            if (!this.validate()) return;
            this.loading = true;
            try {
                // 模拟请求，请替换成真实 API
                const res = await userLogin({
                    username: this.username, password: this.password
                })
                if(res.code === 0) {
                    this.$notify({
                        title:'登录成功',
                        type:'success'
                    })
                    this.$store.commit('SET_TOKEN',res.data.token)
                    saveAuthToken(res.data)
                    this.$router.push('/')
                }
                // if (res.ok && (data.code === 0 || data.access_token || (data.data && data.data.access_token))) {
                //     const token = data.access_token || (data.data && data.data.access_token);
                //     localStorage.setItem("h5_auth_token", token);

                //     const pref = { remember: this.remember };
                //     if (this.remember) pref.username = this.username.trim();
                //     localStorage.setItem("h5_login_pref", JSON.stringify(pref));

                //     this.$emit("login-success", token);
                //     alert("登录成功！");
                // } else {
                //     this.errors.global = data.msg || data.message || "登录失败，请重试";
                // }
            } catch (e) {
                this.errors.global = e.message || "网络错误";
            } finally {
                this.loading = false;
            }
        },
        oauth(provider) {
            const url = `/auth/${provider}?redirect=${encodeURIComponent(window.location.origin + "/auth/callback")}`;
            window.location.href = url;
        },
        onForgot() {
            alert("打开重置密码流程（替换为实际页面）");
        },
        onSignup() {
           this.$router.push('/register')
        }
    }
};
</script>

<style scoped>
/* 样式与 H5 HTML 版本保持一致 */
html,
body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;
    background: #f4f6f8;
    color: #222;
}

.wrap {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 24px 16px;
}

.card {
    width: 100%;
    max-width: 420px;
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.06);
    box-sizing: border-box;
}

.logo {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
}

.logo .icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: linear-gradient(135deg, #667eea, #764ba2);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 700;
}

.title {
    font-size: 18px;
    margin: 0;
}

.subtitle {
    font-size: 12px;
    color: #6b7280;
    margin-top: 4px;
}

.field {
    margin-bottom: 12px;
}

label {
    display: block;
    font-size: 12px;
    color: #374151;
    margin-bottom: 6px;
}

input[type="text"],
input[type="password"] {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid #e6e9ef;
    font-size: 15px;
    box-sizing: border-box;
    background: #fff;
}

.input-with-btn {
    position: relative;
}

.input-with-btn button {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    border: 0;
    background: none;
    font-size: 13px;
    color: #374151;
    cursor: pointer;
}

.actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
}

.checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #374151;
}

.forgot {
    font-size: 13px;
    color: #2563eb;
    text-decoration: none;
}

.btn {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    border: 0;
    background: #2563eb;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
}

.btn[disabled] {
    opacity: 0.6;
    cursor: not-allowed;
}

.oauth {
    display: flex;
    gap: 8px;
    margin-top: 14px;
}

.oauth button {
    flex: 1;
    padding: 10px;
    border-radius: 8px;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    font-weight: 600;
}

.helper {
    margin-top: 12px;
    font-size: 13px;
    color: #6b7280;
    text-align: center;
}

.error {
    color: #e11d48;
    font-size: 13px;
    margin-top: 6px;
}
</style>
